export default function Content({children}) {
    return(
        <div className="Content">
            {/* <h3>{pageName}</h3> */}
            {children}
        </div>
    )
}
